export default __webpack_public_path__ + "static/media/3233 spice rack F top.a45e45e3.png";